import {
  evaluateIntegritySignals,
  type IntegrityScanInput,
} from '../../core/rules/integritySignals';
import { normalizePrivateRunTrace, type PrivateRunTrace } from '../../core/models/PrivateRunTrace';

export interface RunPrivateIntegrityScanParams extends IntegrityScanInput {
  source?: PrivateRunTrace['source'];
  runId?: string;
}

export function signalFingerprint(signals: { code: string; houseId?: string }[]): string {
  if (!signals.length) return '';
  return signals
    .map((s) => `${s.code}:${s.houseId ?? 'global'}`)
    .sort()
    .join('|');
}

export function buildPrivateRunTrace(
  params: RunPrivateIntegrityScanParams,
): PrivateRunTrace {
  const signals = evaluateIntegritySignals(params);
  const runId = params.runId ?? `pr_${Date.now()}`;
  const ts = Date.now();

  return normalizePrivateRunTrace({
    id: runId,
    runId,
    ts,
    source: params.source ?? 'client',
    signals,
    visibility: 'god_only',
  });
}

export function traceHasDangerSignals(trace: PrivateRunTrace): boolean {
  return trace.signals.some((s) => s.severity === 'danger');
}

export function highestSignalSeverity(trace: PrivateRunTrace): 'info' | 'warn' | 'danger' {
  if (trace.signals.some((s) => s.severity === 'danger')) return 'danger';
  if (trace.signals.some((s) => s.severity === 'warn')) return 'warn';
  return 'info';
}
